"use client";

import React, { useCallback, useRef, useState } from "react";
import PopupForm from "@/components/newPageComponent/CommonSection/PopupForm";
import { cards as cmaCardsRaw } from "@/components/newPageComponent/cma-new/main/new/AboutCMA";

import { getFormOneDataFromLocal } from "@/lib/edcrypt";
import {
  isLogo,
  logoSrc,
  logoSrcSet,
  resolveLogoHeight,
  LOGO_IMG_CLASS,
  LOGO_SLOT_CLASS,
  type LogoSizing,
} from "@/components/newPageComponent/CommonSection/companyLogo";

const LOCAL_STORE_NAME = "MILES_NEXT_F1_REF_ENQUIRY";

type Tone = "far" | "aud" | "reg" | "bar" | "part-1" | "part-2";

/** [label, value, tone] — rendered as "value label" inside the score pill. */
type Score = [string, string, Tone];

type TestimonialCard = {
  name: string;
  designation: string;
  /** Logo URL where the employer has a mark, otherwise the employer name. */
  company: string;
  text: string;
  scores: Score[];
  profilePic: string;
  /** Set where the raw mark needs correcting, e.g. a light logo on white. */
  logoFilter?: string;
} & LogoSizing;

const cards: TestimonialCard[] = [
  {
    name: "Sukanya",
    designation: "Audit Associate 2",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/kpmg_logo.png?tr=f-webp,q-70,h-48",
    logoShape: "compact",
    logoHeight: 27,
    text: "Scoring 93 in REG felt achievable because of Miles mocks and Varun Jain's classes. Miles didn't just get me into KPMG, the way REG was taught made me faster at spotting issues than peers from other batches.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Sukanya.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "85", "far"],
      ["AUD", "82", "aud"],
      ["REG", "93", "reg"],
      ["BAR", "88", "bar"],
    ],
  },
  {
    name: "Prashant Gupta",
    designation: "Senior Associate",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/pwc_logo.png?tr=f-webp,q-70,h-48",
    logoShape: "compact",
    text: "Varun Jain sir's auditing classes gave me a clarity that still shows up in how quickly I get up to speed on new engagements at PWC.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Prashant%20Gupta.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "88", "far"],
      ["AUD", "81", "aud"],
      ["REG", "80", "reg"],
      ["BAR", "80", "bar"],
    ],
  },
  // {
  //   name: "Deep Ruparel",
  //   designation: "Asst. Manager",
  //   company:
  //     "https://ik.imagekit.io/mileseducation/miles_website/company/kpmg_logo.png?tr=f-webp,q-70,h-48",
  //   text: "The routine Miles built during my CMA prep is the same discipline that keeps me organized. And at the time of placements, their involvement helped me secure an opportunity at KPMG.",
  //   profilePic:
  //     "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Deep%20Ruparel.png?tr=f-webp,q-70,w-200,h-200,fo-top",
  //   scores: [
  //     ["FAR", "87", "far"],
  //     ["AUD", "79", "aud"],
  //     ["REG", "77", "reg"],
  //     ["BAR", "80", "bar"],
  //   ],
  // },
  {
    name: "Yashwanth Reddy Bobba",
    designation: "Asst. Manager",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/deloitte_logo.png?tr=f-webp,q-70,h-48",
    logoHeight: 20,
    text: "Miles' preparation strategy gave me the clarity to approach problems methodically which helped boost my growth to Assistant Manager at Deloitte today!",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Yashwanth%20Reddy%20Bobba.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "88", "far"],
      ["AUD", "82", "aud"],
      ["REG", "86", "reg"],
      ["BAR", "82", "bar"],
    ],
  },
  {
    name: "Shyam Santoshbhai Dandwani",
    designation: "Sr Audit Analyst",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/wipfli_logo.png?tr=f-webp,q-70,h-48",
    logoHeight: 20,
    text: "Varun Jain's classes made complex concepts simple, and Miles mocks helped me stay consistently exam-ready. How I break down audit problems at Wipfli still traces back to how Varun Jain sir taught us to think.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Shyam%20Santoshbhai%20Dandwani.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "97", "far"],
      ["AUD", "89", "aud"],
      ["REG", "91", "reg"],
      ["BAR", "90", "bar"],
    ],
  },
  {
    name: "Carolyn D Sa",
    designation: "Audit Senior",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/kpmg_logo.png?tr=f-webp,q-70,h-48",
    logoShape: "compact",
    logoHeight: 27,
    text: "Miles kept me focused and exam-ready, their mentor support helped me move up to Audit Senior at KPMG quicker than most.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/CAROLYN%20D%20SA.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "81", "far"],
      ["AUD", "75", "aud"],
      ["REG", "80", "reg"],
      ["BAR", "75", "bar"],
    ],
  },
  {
    name: "Tejas Bhayani",
    designation: "Audit Associate",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/unison_globus_logo.png?tr=f-webp,q-70,h-48",
    logoShape: "stacked",
    logoHeight: 42,
    text: "Miles study materials and revision sessions made learning structured and helped improve across all subjects.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Tejas%20Bhayani.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "86", "far"],
      ["AUD", "78", "aud"],
      ["REG", "82", "reg"],
      ["BAR", "83", "bar"],
    ],
  },
  {
    name: "Jatin Satija",
    designation: "Senior Professional Finance",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/company-logos/DXC.png?tr=f-webp,q-70,h-48",
    logoHeight: 20,
    text: "Breaking down BAR the way Miles taught gave me a problem-solving habit I still use in every review at DXC.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Jatin%20Satija.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "97", "far"],
      ["AUD", "77", "aud"],
      ["REG", "87", "reg"],
      ["BAR", "82", "bar"],
    ],
  },
  {
    name: "Ramandeep Singh",
    designation: "Manager",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/genpact_logo.png?tr=f-webp,q-70,h-48",
    logoShape: "compact",
    text: "Miles mentors constantly guided me, the discipline they instilled is what helps me manage teams at Genpact with more confidence.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Ramandeep%20Singh.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "85", "far"],
      ["AUD", "77", "aud"],
      ["REG", "84", "reg"],
      ["BAR", "77", "bar"],
    ],
  },
  {
    name: "Zalak Sanghavi",
    designation: "US Audit Associate",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/bdo_alliance_usa.png?tr=f-webp,q-70,h-48",
    logoShape: "stacked",
    logoHeight: 34,
    text: "Miles mock tests trained me to work under pressure, so real audit deadlines at BDO feel far more manageable than they do for most new hires.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Zalak%20Sanghavi.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "77", "far"],
      ["AUD", "85", "aud"],
      ["REG", "83", "reg"],
      ["BAR", "79", "bar"],
    ],
  },
  {
    name: "Jaspreet Kaur Dhillon",
    designation: "Assistant Team Lead",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/zeniai_logo.png?tr=f-webp,q-70,h-48",
    logoHeight: 20,
    text: "Never feeling stuck during Miles prep taught me to solve problems independently, a habit that fast-tracked me to team lead at Zeni AI.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Jaspreet%20Kaur%20Dhillon.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "87", "far"],
      ["AUD", "75", "aud"],
      ["REG", "86", "reg"],
      ["BAR", "79", "bar"],
    ],
  },
  {
    name: "Vamshi Teja",
    designation: "Manager",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/eisner_amper_logo.png?tr=f-webp,q-70,h-48",
    logoShape: "compact",
    text: "Miles mock tests trained me for real exam pressure, and that composure has helped me grow into a manager role at EisnerAmper faster than expected.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Vamshi%20Teja.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "82", "far"],
      ["AUD", "89", "aud"],
      ["REG", "77", "reg"],
      ["BAR", "78", "bar"],
    ],
  },
  {
    name: "Prathamesh Bidkar",
    designation: "BI Product Owner",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/maersk_logo.png?tr=f-webp,q-70,h-48",
    text: "Miles flexibility allowed me to balance work and studies without compromising my preparation quality.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Prathamesh%20Bidkar.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "81", "far"],
      ["AUD", "77", "aud"],
      ["REG", "87", "reg"],
      ["BAR", "80", "bar"],
    ],
  },
  {
    name: "Anusha Lalitha Adibhatla",
    designation: "Analyst",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/cohnreznick_logo.png?tr=f-webp,q-70,h-48",
    text: "I got into Cohnreznick because Miles simplified the toughest topics for me, and that clarity is exactly why I pick up new engagements faster than most.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Anusha%20Lalitha%20Adibhatla.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "77", "far"],
      ["AUD", "88", "aud"],
      ["REG", "89", "reg"],
      ["BAR", "76", "bar"],
    ],
  },
  {
    name: "Bobba L P S Mounika",
    designation: "Tax Senior Associate",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/company/sentient_solution_logo.png?tr=f-webp,q-70,h-48",
    text: "Miles' consistent practice built a work ethic that helps me handle complex tax cases at Sentient Solutions with more ease than expected.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Bobba%20L%20P%20S%20Mounika.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "80", "far"],
      ["AUD", "77", "aud"],
      ["REG", "85", "reg"],
      ["BAR", "80", "bar"],
    ],
  },
  {
    name: "Vineet Kour",
    designation: "Junior Accountant",
    company:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-course/why-miles/Xshore.webp",
    logoFilter: "brightness(0)",
    text: "Scoring 93 in REG was possible because of Miles mocks and revision strategy, I was perfectly exam ready even after being under pressure.",
    profilePic:
      "https://ik.imagekit.io/mileseducation/miles_website/home_2026/alumni/Vineet%20Kour.png?tr=f-webp,q-70,w-200,h-200,fo-top",
    scores: [
      ["FAR", "88", "far"],
      ["AUD", "86", "aud"],
      ["REG", "93", "reg"],
      ["BAR", "79", "bar"],
    ],
  },
];

/** CMA cards now carry the same shape, so they drop straight in. */
const cmaCards = cmaCardsRaw as TestimonialCard[];

const interleave = <T,>(a: T[], b: T[]): T[] => {
  const result: T[] = [];
  const max = Math.max(a.length, b.length);
  for (let i = 0; i < max; i++) {
    if (i < a.length) result.push(a[i]);
    if (i < b.length) result.push(b[i]);
  }
  return result;
};

const mixedCards = interleave(cards, cmaCards);

const NavButton = ({
  direction,
  onClick,
}: {
  direction: "prev" | "next";
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={direction === "prev" ? "Previous story" : "Next story"}
    className={`hidden md:flex absolute top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full border border-[#2f89ea] text-[#2f89ea] bg-white transition-colors hover:bg-[#2f89ea] hover:text-white ${
      direction === "prev" ? "left-0" : "right-0"
    }`}
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-4 h-4"
      aria-hidden="true"
    >
      {direction === "prev" ? (
        <path d="M19 12H5m0 0 6-6m-6 6 6 6" />
      ) : (
        <path d="M5 12h14m0 0-6-6m6 6-6 6" />
      )}
    </svg>
  </button>
);

const CardItem = ({ card, uid }: { card: TestimonialCard; uid: string }) => {
  const logoHeight = resolveLogoHeight(card);

  return (
    <article
      className="h-full flex flex-col items-center text-center bg-white rounded-2xl shadow-[0_5px_20px_-4px_rgba(0,0,0,0.12),0_0_8px_rgba(0,0,0,0.05)] px-4 py-4 max-md:px-4 max-md:py-4"
      aria-label={`Testimonial by ${card.name}`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- ImageKit URLs
        already carry their transforms, so no loader is needed. */}
      <img
        src={card.profilePic}
        alt={card.name}
        width={100}
        height={100}
        loading="lazy"
        decoding="async"
        className="w-[85px] h-[85px] md:w-[100px] md:h-[100px] rounded-full object-cover"
      />

      <h3 className="mt-4 text-[#3a73ac] text-base md:text-[20px] font-bold leading-tight">
        {card.name}
      </h3>
      {card.designation && (
        <p className="text-[#3a73ac] text-sm md:text-base font-semibold">
          {card.designation}
        </p>
      )}

      {/* Employers without a mark in the asset sheet get their name set in type
        in the same slot, so the row below it stays aligned. */}
      <span className={LOGO_SLOT_CLASS}>
        {isLogo(card.company) ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={logoSrc(card.company, logoHeight)}
            srcSet={logoSrcSet(card.company, logoHeight)}
            alt={card.name}
            loading="lazy"
            decoding="async"
            style={{
              maxHeight: logoHeight,
              ...(card.logoFilter ? { filter: card.logoFilter } : {}),
            }}
            className={LOGO_IMG_CLASS}
          />
        ) : (
          <span className="text-sm font-bold text-[#333]">{card.company}</span>
        )}
      </span>

      {/* Clamped because the quotes run from one line to four sentences, and
        items-stretch means the longest one would set the height of them all. */}
      <p className="mt-3 text-black text-xs md:text-sm leading-[22px] line-clamp-5">
        {card.text}
      </p>

      <div className="flex flex-wrap justify-center gap-2 mt-auto pt-5">
        {card.scores.map(([label, value]) => (
          <span
            key={`${uid}-${label}`}
            className="bg-[#2f6fb3] text-white text-[10px] font-bold rounded-full px-2.5 py-1 whitespace-nowrap"
          >
            {value} {label}
          </span>
        ))}
      </div>
    </article>
  );
};

interface AboutCPAProps {
  pageName?: string;
}

const AboutCMA: React.FC<AboutCPAProps> = ({ pageName = "CPA" }) => {
  const [isFormPopupOpen, setFormPopupOpen] = useState(false);
  const trackRef = useRef<HTMLDivElement>(null);

  const isCombined = pageName === "CPA/CMA";
  const slides = isCombined ? mixedCards : cards;

  const scrollByCard = useCallback((direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 0) return;

    const card = track.firstElementChild as HTMLElement | null;
    const step = card ? card.offsetWidth : track.clientWidth / 3;

    let next = track.scrollLeft + direction * step;
    // 1px of tolerance for sub-pixel scroll positions.
    if (next > maxScroll + 1) {
      next = 0;
    } else if (next < -1) {
      next = maxScroll;
    }

    track.scrollTo({ left: next, behavior: "smooth" });
  }, []);

  const scrollPrev = useCallback(() => scrollByCard(-1), [scrollByCard]);
  const scrollNext = useCallback(() => scrollByCard(1), [scrollByCard]);

  const openFormPopup = (redirectUrl: string) => {
    const { status: isFormOneFilled } =
      getFormOneDataFromLocal(LOCAL_STORE_NAME);
    if (isFormOneFilled) {
      window.open(redirectUrl, "_blank");
      return;
    }
    sessionStorage.setItem("modal-open", "true");
    setFormPopupOpen(true);
  };

  const closeFormPopup = () => {
    sessionStorage.removeItem("modal-open");
    setFormPopupOpen(false);
  };

  const handleJoinCommunity = () =>
    openFormPopup("https://www.linkedin.com/school/mileseducation/");

  const handleEligibilityCheck = () =>
    openFormPopup("https://cpa-course.mileseducation.com/eligibility");

  return (
    <>
      <section
        className="max-md:px-4 max-md:pt-6 max-md:pb-0 bg_white_new"
        aria-labelledby="about-cpa-title"
      >
        <div className="main_container py-[50px] max-md:px-0 max-md:pt-5 max-md:pb-8 max-md:bg-white max-md:rounded-2xl">
          <h2
            id="about-cpa-title"
            className="m-0 text-center text-[32px] leading-[1.15] font-bold tracking-[-0.02em] text-[#333] max-md:text-2xl max-md:px-4"
          >
            <span className="text-[#2f89ea]">80%</span> of CPAs in India are
            Miles Alumni
          </h2>
          <p className="max-w-[636px] mx-auto mt-4 text-center text-sm leading-[1.6] text-[#999] font-medium max-md:px-4 [&>span]:font-bold">
            Meet CPAs across India who transformed their careers through{" "}
            <strong>
              Miles Education’s world-class LMS, engaging video lessons, and
              expert 1-on-1 mentorship
            </strong>
          </p>

          <div className="relative pt-8 max-md:pt-5 md:px-14">
            <NavButton direction="prev" onClick={scrollPrev} />

            <div
              ref={trackRef}
              className="scrollbar-hide flex items-stretch snap-x snap-mandatory overflow-x-auto overflow-y-hidden overscroll-x-contain px-[calc((100%-280px)/2)] md:px-0 md:mx-auto md:max-w-[1128px]"
            >
              {slides.map((card, i) => (
                <div
                  key={`story-${i}`}
                  className="w-[280px] md:w-[376px] shrink-0 snap-center md:snap-start px-2 md:px-3 py-4"
                >
                  <CardItem card={card} uid={`story-${i}`} />
                </div>
              ))}
            </div>

            <NavButton direction="next" onClick={scrollNext} />
          </div>

          <p className="md:hidden mt-2 text-center text-xs font-bold text-[#3A73AC]">
            &larr; Swipe to explore &rarr;
          </p>

          <div className="mt-8 max-md:mt-5 flex justify-center items-center gap-7 flex-wrap max-md:flex-col max-md:gap-3.5 max-md:px-5">
            <button
              onClick={handleJoinCommunity}
              className="text-[15px] font-bold no-underline cursor-pointer transition-all duration-200 hover:opacity-90 hover:-translate-y-px rounded-lg bg-[#2a85ff] text-white px-9 py-2.5 max-md:text-base max-md:w-full max-md:py-3 max-md:text-center max-md:box-border"
            >
              Join the Community
            </button>

            <button
              onClick={handleEligibilityCheck}
              className="text-[15px] font-bold cursor-pointer transition-all duration-200 hover:opacity-90 hover:-translate-y-px text-[#2A85FF] underline underline-offset-4 max-md:text-sm"
            >
              Get a Free Eligibility Check
            </button>
          </div>
        </div>
      </section>

      {isFormPopupOpen && (
        <PopupForm handleClose={closeFormPopup} pageName={pageName} />
      )}
    </>
  );
};

export default AboutCMA;
